import { render, staticRenderFns } from "./LastFeed.vue?vue&type=template&id=67bb7bd3&scoped=true&"
import script from "./LastFeed.vue?vue&type=script&lang=js&"
export * from "./LastFeed.vue?vue&type=script&lang=js&"
import style0 from "./LastFeed.vue?vue&type=style&index=0&id=67bb7bd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bb7bd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
